module.exports = __webpack_public_path__ + "static/media/Zeigarnik Effect.3c694e8f.jpg";